module.exports = __webpack_public_path__ + "img/rotationArrow.db1276d1.svg";